import React from 'react';
import { Phone, AlertTriangle, Snowflake, Droplets, Wind } from 'lucide-react';
const PHONE = '586-203-3701';
export function RoofReplacement() {
  const signs = [{
    Icon: AlertTriangle,
    title: 'Curling or Missing Shingles',
    body: 'A clear sign your roof has reached the end of its life.'
  }, {
    Icon: Droplets,
    title: 'Leaks or Water Stains',
    body: 'Interior water damage means moisture is getting past the shingles.'
  }, {
    Icon: Snowflake,
    title: 'Ice Dams in Winter',
    body: 'Common in Michigan — often points to ventilation and insulation issues.'
  }, {
    Icon: Wind,
    title: 'Storm or Hail Damage',
    body: 'Even one strong Michigan storm can cause hidden damage.'
  }, {
    Icon: AlertTriangle,
    title: 'Granules in Gutters',
    body: 'Excessive granule loss means your shingles are wearing out.'
  }, {
    Icon: AlertTriangle,
    title: 'Roof Is 20+ Years Old',
    body: 'Most asphalt shingle roofs need replacement after two decades.'
  }];
  return <section className="bg-slate-50 py-20 sm:py-24" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-204">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-205">
            Roof Replacement
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-4" data-id="element-206">
            Does Your Roof Need to Be Replaced?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-207">
            If you're seeing any of these warning signs, don't wait. A free
            inspection from Moceri will give you a straight answer — no
            high-pressure sales tactics.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12" data-id="element-208">
          {signs.map(({
          Icon,
          title,
          body
        }) => <div key={title} className="bg-white rounded-xl p-6 border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all" data-id="element-209">
              <Icon className="w-8 h-8 text-[#2DB8E0] mb-4" data-id="element-210" />
              <h3 className="font-bold text-[#1a2332] text-lg mb-2" data-id="element-211">{title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-212">{body}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-213">
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-3 bg-[#1a2332] hover:bg-[#2d3a4d] text-white font-bold text-lg px-8 py-4 rounded-full transition-colors shadow-lg" data-id="element-214">
            <Phone className="w-5 h-5 text-[#2DB8E0]" data-id="element-215" />
            Call Now for a Free Inspection: {PHONE}
          </a>
        </div>
      </div>
    </section>;
}